import React from "react";
import { Form } from "react-bootstrap";
import {
  HiCheck,
  HiOutlineAdjustmentsHorizontal,
  HiOutlineArrowPathRoundedSquare,
  HiOutlineCurrencyDollar,
  HiOutlineXMark,
  HiXMark,
} from "react-icons/hi2";
import "./PaperOverrideDrawer.css";

export default function PaperOverrideDrawer(props) {
  const {
    show,
    onHide,
    credit_purchase_flag,
    amount_purchase_flag,
    override_credit,
    override_amount,
    no_of_credits,
    no_of_credits_error,
    price,
    price_error,
    price_currency_type_id,
    allCurrencyTypes,
    disabled,
    validator,
    handleChange,
    handleChangeCurrencyType,
    handleSubmit,
    setDrawerState,
  } = props;

  return (
    <div
      className={`paper-override-drawer-layer ${show ? "is-open" : ""}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="paper-override-title"
      aria-hidden={!show}
    >
      <button
        type="button"
        className="paper-override-backdrop"
        onClick={onHide}
        aria-label="Close drawer backdrop"
      />

      <aside className="paper-override-drawer-panel">
        <div className="paper-override-drawer-header">
          <div className="paper-override-drawer-title-wrap">
            <span className="paper-override-drawer-icon">
              <HiOutlineAdjustmentsHorizontal />
            </span>
            <div>
              <h2 id="paper-override-title" className="paper-override-drawer-title">Override Details</h2>
              <p className="paper-override-drawer-subtitle">
                Update the display settings without changing the existing logic.
              </p>
            </div>
          </div>
          <button type="button" className="paper-override-close-btn" onClick={onHide} aria-label="Close drawer">
            <HiOutlineXMark />
          </button>
        </div>

        <Form onSubmit={handleSubmit} className="paper-override-form-shell">
          <div className="paper-override-drawer-body">
            <div className="paper-override-section">
              <div className="paper-override-section-header">
                <HiOutlineArrowPathRoundedSquare />
                <span>Availability</span>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 mb-4">
                  <Form.Label className="paper-override-label">Credit Purchase</Form.Label>
                  <div className="paper-override-toggle-group">
                    <button
                      type="button"
                      className={`paper-override-toggle-btn ${credit_purchase_flag === 1 ? "is-active is-success" : ""}`}
                      onClick={() => setDrawerState({ credit_purchase_flag: 1 })}
                      disabled={override_credit !== 1}
                    >
                      <HiCheck />
                      <span>On</span>
                    </button>
                    <button
                      type="button"
                      className={`paper-override-toggle-btn ${credit_purchase_flag === 0 ? "is-active is-danger" : ""}`}
                      onClick={() => setDrawerState({ credit_purchase_flag: 0 })}
                      disabled={override_credit !== 1}
                    >
                      <HiXMark />
                      <span>Off</span>
                    </button>
                  </div>
                </div>

                <div className="col-12 col-md-6 mb-4">
                  <Form.Label className="paper-override-label">Cash Purchase</Form.Label>
                  <div className="paper-override-toggle-group">
                    <button
                      type="button"
                      className={`paper-override-toggle-btn ${amount_purchase_flag === 1 ? "is-active is-success" : ""}`}
                      onClick={() => setDrawerState({ amount_purchase_flag: 1 })}
                      disabled={override_amount !== 1}
                    >
                      <HiCheck />
                      <span>On</span>
                    </button>
                    <button
                      type="button"
                      className={`paper-override-toggle-btn ${amount_purchase_flag === 0 ? "is-active is-danger" : ""}`}
                      onClick={() => setDrawerState({ amount_purchase_flag: 0 })}
                      disabled={override_amount !== 1}
                    >
                      <HiXMark />
                      <span>Off</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="paper-override-section">
              <div className="paper-override-section-header">
                <HiOutlineCurrencyDollar />
                <span>Override controls</span>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 mb-4">
                  <Form.Label className="paper-override-label">Override Credit</Form.Label>
                  <div className="paper-override-toggle-group">
                    <button
                      type="button"
                      className={`paper-override-toggle-btn ${override_credit === 1 ? "is-active is-success" : ""}`}
                      onClick={() => setDrawerState({ override_credit: 1 })}
                    >
                      <HiCheck />
                      <span>On</span>
                    </button>
                    <button
                      type="button"
                      className={`paper-override-toggle-btn ${override_credit === 0 ? "is-active is-danger" : ""}`}
                      onClick={() => setDrawerState({ override_credit: 0 })}
                    >
                      <HiXMark />
                      <span>Off</span>
                    </button>
                  </div>
                </div>

                <div className="col-12 col-md-6 mb-4">
                  <Form.Label className="paper-override-label">Override Amount</Form.Label>
                  <div className="paper-override-toggle-group">
                    <button
                      type="button"
                      className={`paper-override-toggle-btn ${override_amount === 1 ? "is-active is-success" : ""}`}
                      onClick={() => setDrawerState({ override_amount: 1 })}
                    >
                      <HiCheck />
                      <span>On</span>
                    </button>
                    <button
                      type="button"
                      className={`paper-override-toggle-btn ${override_amount === 0 ? "is-active is-danger" : ""}`}
                      onClick={() => setDrawerState({ override_amount: 0 })}
                    >
                      <HiXMark />
                      <span>Off</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="paper-override-section">
              <div className="row">
                {credit_purchase_flag === 1 && (
                  <div className="col-12 mb-4">
                    <Form.Group>
                      <Form.Label className="paper-override-label">No of Credits*</Form.Label>
                      <Form.Control
                        placeholder="Enter no of credits..."
                        name="no_of_credits"
                        type="number"
                        value={no_of_credits || ""}
                        onChange={handleChange}
                        min={0}
                        disabled={override_credit !== 1}
                        className="paper-override-input"
                      />
                      {no_of_credits_error && <div className="paper-override-error">{no_of_credits_error}</div>}
                      {override_credit === 1 &&
                        validator.message("no_of_credits", no_of_credits, "required|number", {
                          className: "paper-override-error",
                        })}
                    </Form.Group>
                  </div>
                )}

                {amount_purchase_flag === 1 && (
                  <>
                    <div className="col-12 col-md-8 mb-4">
                      <Form.Group>
                        <Form.Label className="paper-override-label">Amount*</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Enter amount value..."
                          name="price"
                          value={price || ""}
                          onChange={handleChange}
                          disabled={override_amount !== 1}
                          className="paper-override-input"
                        />
                        {price_error && <div className="paper-override-error">{price_error}</div>}
                        {override_amount === 1 &&
                          validator.message("price", price, "required|number", {
                            className: "paper-override-error",
                          })}
                      </Form.Group>
                    </div>

                    <div className="col-12 col-md-4 mb-4">
                      <Form.Group>
                        <Form.Label className="paper-override-label">Currency</Form.Label>
                        <Form.Select
                          id="currency_types"
                          value={price_currency_type_id || 1}
                          onChange={handleChangeCurrencyType}
                          disabled={override_amount !== 1}
                          className="paper-override-select"
                        >
                          {allCurrencyTypes.map((option, index) => (
                            <option key={index} value={option.currency_type_id}>
                              {option.name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="paper-override-footer">
            <button type="submit" className="paper-override-save-btn" disabled={disabled}>
              <HiCheck />
              <span>Save changes</span>
            </button>
            <button type="button" className="paper-override-cancel-btn" onClick={onHide}>
              <HiOutlineXMark />
              <span>Close</span>
            </button>
          </div>
        </Form>
      </aside>
    </div>
  );
}
